import { useMemo } from 'react'

import { useExportAnalyticsReportCSV } from '../../../hooks/useExportAnalyticsReportCSV'
import { useAnalyticsParams } from '../../../modules/AnalyticsParams/hooks/useAnalyticsParams'
import { useAnalyticsContext } from '../../../providers/AnalyticsProvider'
import { getExternalSource } from '../../../utils/getExternalSource'
import type { AnalyticsReportsItem } from '../AnalyticsReports.types'

export const useAnalyticsReportsData = () => {
  const { reportsDefinitions, isLoading } = useAnalyticsContext()
  const { exportReportCSV } = useExportAnalyticsReportCSV()
  const params = useAnalyticsParams()

  const data: AnalyticsReportsItem[] = useMemo(
    () =>
      reportsDefinitions
        .map((reportDefinition) => ({
          id: reportDefinition.id,
          name: reportDefinition.name,
          decorator: reportDefinition.decorator,
          externalSource: getExternalSource(reportDefinition.dataSource),
          supportsSelectedPrecision: reportDefinition.availableAggregationPrecisions.length
            ? reportDefinition.availableAggregationPrecisions.includes(params.precision.value.value)
            : true,
        }))
        .sort((a, b) => {
          if (a.externalSource === 'googleAnalytics' && b.externalSource !== 'googleAnalytics') {
            return -1
          }

          if (a.externalSource !== 'googleAnalytics' && b.externalSource === 'googleAnalytics') {
            return 1
          }

          return a.name.localeCompare(b.name)
        }),
    [params.precision.value.value, reportsDefinitions],
  )

  return {
    data,
    params,
    isLoading,
    onExport: exportReportCSV,
  }
}
